import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	ariaLabelForSelect: {
		id: 'issue-field-select-with-analytics.ariaLabel',
		defaultMessage: 'Select Field',
		description: 'ariaLabel for select field',
	},
});
